var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.$props.errors.length)?_c('div',{staticClass:"mb-3"},_vm._l((_vm.$props.errors),function(error,index){return _c('BaseAlert',{key:("bdx-wizard-error-" + index),staticClass:"py-2 px-3",class:{
      'mb-2': index < _vm.lastIndex,
      'mb-0': index === _vm.lastIndex
    },attrs:{"variant":"danger"}},[_c('strong',{staticClass:"text-capitalize font-weight-bold"},[_vm._v(_vm._s(error.label)+":")]),_vm._v("\n    "+_vm._s(error.message)+"\n  ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }